export default __webpack_public_path__ + "static/video-thumb-default-624b2748edf40e067a0504335a9b107b.jpg";